import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1 className="title">404</h1>
      <p className="message">{t("pageNotFound") || "הדף לא נמצא"}</p>
      <Link className="home-button" to="/">
        {t("backToHome") || "חזרה לדף הבית"}
      </Link>
    </div>
  );
};

export default NotFound;
